export default "__VITE_ASSET__db0b0faf__"